/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Note_AgentInputs */

const en_hub_note_agent = /** @type {(inputs: Hub_Note_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bystep init installs the task loop into the agent config your repo already has; the MCP server exposes the same loop as tools.`)
};

const id_hub_note_agent = /** @type {(inputs: Hub_Note_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bystep init memasang alur task ke konfigurasi agen yang sudah ada di repo Anda; server MCP menyediakan alur yang sama sebagai tool.`)
};

/**
* | output |
* | --- |
* | "bystep init installs the task loop into the agent config your repo already has; the MCP server exposes the same loop as tools." |
*
* @param {Hub_Note_AgentInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_note_agent = /** @type {((inputs?: Hub_Note_AgentInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Note_AgentInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_note_agent(inputs)
	return en_hub_note_agent(inputs)
});